import styled from 'styled-components'
import Link from 'next/link'
import { COMPLETED, INPROGRESS, INREVIEW } from 'utils/project-status'
import { Typography } from 'common/typography'

const ProjectStepStatusStyled = styled.div`
  display: flex;
  align-items: center;
  ${({ disabled }) => disabled && 'opacity: 0.5;'}
  margin: 16px 0 24px;
  .project-status-icon {
    width: 32px;
    height: 32px;
    margin-right: 2px;
  }
  .to-revise-icon {
    background-image: url(/images/profile/solicitud.png);
    background-size: 864px 32px;
    background-position: -2px 0px;
  }
  .feedback-icon {
    background-image: url(/images/profile/feedback-sprite.png);
    background-size: 864px 32px;
    background-position: -2px 0px;
  }
  .in-revision-icon {
    background-image: url(/images/profile/revision-sprite.png);
    background-size: 864px 32px;
  }
  .completed-icon {
    background-image: url(/images/profile/completed-sprite.png);
    background-size: 864px 32px;
  }
  p {
    color: var(--turquoise);
    font-weight: 700;
    margin: 0;
  }
`

function ProjectStepStatus({ slug, projectStatus }) {
  if (!projectStatus) {
    return (
      <ProjectStepStatusStyled disabled revision>
        <div className="project-status-icon to-revise-icon" />
        <Typography as="p" small="smallRegular" large="p2Regular">
          Solicitar revisión
        </Typography>
      </ProjectStepStatusStyled>
    )
  }

  const { status, feedback } = projectStatus

  return (
    <Link href={`/estudiante#${slug}`} passHref>
      <ProjectStepStatusStyled>
        <div
          className={
            (status === INPROGRESS && 'project-status-icon to-revise-icon')
            || ((status === INPROGRESS && feedback) && 'project-status-icon feedback-icon')
            || (status === INREVIEW && 'project-status-icon in-revision-icon')
            || (status === COMPLETED && 'project-status-icon completed-icon')
          }
        />
        <Typography as="p" small="smallRegular" large="p2Regular">
          {(status === COMPLETED) && 'Aprobado'}
          {(status === INPROGRESS && !feedback) && 'Solicitar Revisión'}
          {(status === INPROGRESS && feedback) && 'Contiene feedback'}
          {(status === INREVIEW) && 'En revisión'}
        </Typography>
      </ProjectStepStatusStyled>
    </Link>
  )
}

export default ProjectStepStatus
